export function logoutFakeUser(setToken, navigate) {
    sessionStorage.removeItem('token');
    sessionStorage.clear();
    setToken(null);
    navigate('/login');
}
